import _defineProperty from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _Auth;

import Api, { API_ROOT as API, ACCOUNT_USER, ACCOUNT_PING, ACCOUNT_TOKEN, ACCOUNT_LOGIN, ACCOUNT_LOGOUT, ACCOUNT_CHANGE_PASSWORD, ACCOUNT_RESET_PASSWORD, ACCOUNT_FORGOT_PW, ACCOUNT_FORGOT_PW_CONFIRM, VALIDATE_MFA_CODE } from '@defi/core-api';
import Logout from './logout';
import Token from './token';
import Location from './location';
import { PATH_ROOT, PATH_DASHBOARD, PATH_LOGIN_EXPIRED, ROUTE_LOGIN_EXPIRED, REQUIRE_AUTH } from '@defi/core-constants';
import filterByPathAndArea from './filterByPathAndArea';
import { List } from 'immutable';
var Auth = (_Auth = {
  profile: function profile() {
    var profileCondition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PasswordExpired';
    var token = new Token();
    var currentProfile = token.getProfile();
    return currentProfile[profileCondition];
  },
  can: function can() {
    var canPermission = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var token = new Token();
    var currentPermissions = token.getPermissions();
    return currentPermissions && currentPermissions.List && currentPermissions.List.indexOf(canPermission) > -1;
  },
  ping: function ping() {
    return Api.get(API.auth, ACCOUNT_PING).then(function (response) {
      var token = new Token();
      var currentProfile = token.getProfile();
      var pingUsername = response.username.toLowerCase();
      var profileUsername = currentProfile.UserName.toLowerCase();

      if (pingUsername.localeCompare(profileUsername) === 0) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message));
      }
    }).catch(function (error) {
      if (error && error.response && error.response.status === 401) {
        Logout.logoutDirectlyToNewLogout();
      }
    });
  },
  user: function user() {
    return Api.get(API.auth, ACCOUNT_USER).then(function (response) {
      if (response.hasOwnProperty('success') && response.success) {
        var token = new Token();
        token.deleteSession();
        token.setExpiration(response.expires);
        token.setProfile(response.Profile);
        token.setPermissions(response.Permissions);
        token.setPagePermissions(response.PagePermissions);
        token.setCreated(response.created);
        token.setRefresh(response.refresh);
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message));
      }
    }).catch(function (error) {
      return Promise.reject(error);
    });
  },
  token: function token() {
    return Api.get(API.auth, ACCOUNT_TOKEN).then(function (response) {
      var token = new Token();
      token.setExpiration(response.expires);
      token.setProfile(response.Profile);
      token.setPermissions(response.Permissions);
      token.setPagePermissions(response.PagePermissions);
      token.setCreated(response.created);
      token.setRefresh(response.refresh);
      return Promise.resolve(response);
    }).catch(function (error) {
      return Promise.reject(error);
    });
  },
  verifyIsDefiUser: function verifyIsDefiUser() {
    // Get our data
    var token = new Token();
    var currentExpiration = token.getExpiration();
    var currentProfile = token.getProfile();

    if (currentExpiration === null) {
      Logout.logoutDirectlyToNewLogout();
    } // Check expiration


    var expiredDate = currentExpiration;
    var currentTime = new Date().getTime();
    var currentTimeStamp = Math.floor(currentTime / 1000);

    if (expiredDate <= currentTimeStamp) {
      Logout.logoutDirectlyToNewLogout();
    } // Check ForceLogoff field


    if (!currentProfile || currentProfile.ForceLogoff === true) {
      Logout.logoutForced();
    } // Check PasswordExpired field


    if (currentProfile.PasswordExpired === true && path !== ROUTE_LOGIN_EXPIRED) {
      // eslint-disable-next-line
      Location.redirect(PATH_LOGIN_EXPIRED);
    }

    return currentProfile.UserName.startsWith("defi-");
  },
  verification: function verification() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var requireEditAbility = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var ignorePermissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var requiredConditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // Get our data
    var token = new Token();
    var currentExpiration = token.getExpiration();
    var currentProfile = token.getProfile();
    var currentPagePermissions = token.getPagePermissions();

    if (currentExpiration === null) {
      Logout.logoutDirectlyToNewLogout();
    } // Check expiration


    var expiredDate = currentExpiration;
    var currentTime = new Date().getTime();
    var currentTimeStamp = Math.floor(currentTime / 1000);

    if (expiredDate <= currentTimeStamp) {
      Logout.logoutDirectlyToNewLogout();
    } // Check ForceLogoff field


    if (!currentProfile || currentProfile.ForceLogoff === true) {
      Logout.logoutForced();
    } // Check PasswordExpired field


    if (currentProfile.PasswordExpired === true && path !== ROUTE_LOGIN_EXPIRED) {
      // eslint-disable-next-line
      Location.redirect(PATH_LOGIN_EXPIRED);
    } // Check if we are ignoring permissions and skip check below


    if (ignorePermissions) {
      if (requiredConditions && requiredConditions.Can && !this.can(requiredConditions.Can)) {
        // redirect to dashboard doesn't have needed Can Permission
        Location.redirect(PATH_DASHBOARD);
      } // check if needs a Profile Condition


      if (requiredConditions && requiredConditions.Profile && !this.profile(requiredConditions.Profile)) {
        // redirect to dashboard doesn't have needed Profile Condition
        Location.redirect(PATH_DASHBOARD);
      }

      return true;
    } // Check CanView and CanViewAndEdit permissions
    //  - Users may have only CanViewAndEdit permissions
    //  - Users may have both permissions


    if (currentPagePermissions.CanViewAndEdit.filter(filterByPathAndArea(path)).length === 1) {
      return true;
    } else if (!requireEditAbility && currentPagePermissions.CanView.filter(filterByPathAndArea(path)).length === 1) {
      return true;
    } else {
      // if (path === PATH_ROOT) {
      //   window.location = PATH_DASHBOARD;
      // } else {
      return false; // }
    } // We are looking good


    return true;
  },
  login: function login(username, password) {
    return Api.post(API.auth, ACCOUNT_LOGIN, {
      username: username,
      password: password,
      rememberMe: true
    }).then(function (response) {
      if (response.MfaChallenge) {
        var token = new Token();
        token.setMfaSession(response.MfaChallenge);
        return Promise.resolve(response);
      } else if (Object.keys(response).length !== 0) {
        var _token = new Token();

        _token.setExpiration(response.expires);

        _token.setCreated(response.created);

        _token.setRefresh(response.refresh);

        _token.setProfile(response.Profile);

        _token.setPermissions(response.Permissions);

        _token.setPagePermissions(response.PagePermissions);

        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message)); //return Promise.reject(new Error('Unable to retrieve data.'));
      }
    }).catch(function (error) {
      return Promise.reject(error); //return Promise.reject(new Error('Unable to retrieve data.'));
    });
  },
  ssoLogin: function ssoLogin(response) {
    if (Object.keys(response).length !== 0) {
      var token = new Token();
      token.setExpiration(response.expires);
      token.setCreated(response.created);
      token.setRefresh(response.refresh);
      token.setProfile(response.Profile);
      token.setPermissions(response.Permissions);
      token.setPagePermissions(response.PagePermissions);
      return Promise.resolve(response);
    }
  },
  validateMfa: function validateMfa(username, password, mfacode, rememberMe) {
    var token = new Token();
    var mfaSessionData = token.getMfaSession();
    var mfaSession = mfaSessionData.SessionId;
    return Api.post(API.auth, VALIDATE_MFA_CODE, {
      username: username,
      password: password,
      mfacode: mfacode,
      mfaSession: mfaSession,
      MfaRememberThisDeviceRequested: rememberMe
    }).then(function (response) {
      if (Object.keys(response).length !== 0) {
        var _token2 = new Token();

        _token2.setExpiration(response.expires);

        _token2.setCreated(response.created);

        _token2.setRefresh(response.refresh);

        _token2.setProfile(response.Profile);

        _token2.setPermissions(response.Permissions);

        _token2.setPagePermissions(response.PagePermissions);

        _token2.deleteMfaSession();

        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message)); //return Promise.reject(new Error('Unable to retrieve data.'));
      }
    }).catch(function (error) {
      return Promise.reject(error); //return Promise.reject(new Error('Unable to retrieve data.'));
    });
  },
  changePassword: function changePassword(username, newPassword, clientID, currentPassword, mfaAccessToken) {
    var body = {
      Username: username,
      NewPassword: newPassword,
      ClientId: clientID,
      CurrentPassword: currentPassword
    };
    if (mfaAccessToken && mfaAccessToken.length > 0) body.AccessToken = mfaAccessToken;
    return Api.post(API.auth, ACCOUNT_CHANGE_PASSWORD, body).then(function (response) {
      if (Object.keys(response).length !== 0) {
        if (response.Errors) return Promise.resolve(response);
        var token = new Token();
        token.setExpiration(response.expires);
        token.setProfile(response.Profile);
        token.setPermissions(response.Permissions);
        token.setPagePermissions(response.PagePermissions);
        return Promise.resolve(response);
      }
    }).catch(function (error) {
      return Promise.reject(new Error('Unable to retrieve data.'));
    });
  },
  resetPassword: function resetPassword(username, newPassword, clientID) {
    return Api.post(API.auth, ACCOUNT_RESET_PASSWORD, {
      Username: username,
      NewPassword: newPassword,
      ClientId: clientID
    });
  },
  forgotPassword: function forgotPassword(username, clientID) {
    return Api.post(API.auth, ACCOUNT_FORGOT_PW, {
      UserName: username
    });
  },
  forgotPasswordConfirm: function forgotPasswordConfirm(username, password, mfaCode, clientID) {
    return Api.post(API.auth, ACCOUNT_FORGOT_PW_CONFIRM, {
      UserName: username,
      Password: password,
      ConfirmationCode: mfaCode
    });
  },
  userPermissionMatchLocalStorage: function userPermissionMatchLocalStorage(user) {}
}, _defineProperty(_Auth, "user", function user() {
  return Api.get(API.auth, ACCOUNT_USER).then(function (response) {
    if (Object.keys(response).length !== 0) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(new Error(response.Message)); //return Promise.reject(new Error('Unable to retrieve data.'));
    }
  }).catch(function (error) {
    new Token().deleteSession();
    return Promise.reject(error);
  });
}), _defineProperty(_Auth, "canView", function canView() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var authOff = arguments.length > 1 ? arguments[1] : undefined;

  // Check if auth is turned off
  if (!REQUIRE_AUTH || authOff) {
    return true;
  } // Get path & page permissions


  var currentPagePermissions = new Token().getPagePermissions();

  if (currentPagePermissions == null) {
    return false;
  } else {
    if (pathname == null) {
      pathname = window.location.pathname;
    }

    var pathnameAlt = null;

    if (pathname.substr(-1) !== '/') {
      pathnameAlt = pathname + '/';
    } // Check if pathname is in page permissions


    if (currentPagePermissions.CanView.filter(filterByPathAndArea(pathname)).length === 1 || pathnameAlt !== null && currentPagePermissions.CanView.filter(filterByPathAndArea(pathnameAlt)).length === 1) {
      return true;
    } else {
      return false;
    }
  }
}), _defineProperty(_Auth, "canViewAndEdit", function canViewAndEdit() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var authOff = arguments.length > 1 ? arguments[1] : undefined;

  // Check if auth is turned off
  if (!REQUIRE_AUTH || authOff) {
    return true;
  } // Get path & page permissions


  var currentPagePermissions = new Token().getPagePermissions();

  if (currentPagePermissions == null) {
    return false;
  } else {
    if (pathname == null) {
      pathname = window.location.pathname;
    }

    var pathnameAlt = null;

    if (pathname.substr(-1) !== '/') {
      pathnameAlt = pathname + '/';
    } // Check if pathname is in page permissions


    if (currentPagePermissions.CanViewAndEdit.filter(filterByPathAndArea(pathname)).length === 1 || pathnameAlt !== null && currentPagePermissions.CanViewAndEdit.filter(filterByPathAndArea(pathnameAlt)).length === 1) {
      return true;
    } else {
      return false;
    }
  }
}), _defineProperty(_Auth, "checkPermissions", function checkPermissions() {
  var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : List([]);
  // Get special permissions
  var currentPermissions = new Token().getPermissions(); // Make sure the data type of the permissions object is a list

  if (!List.isList(permissions)) {
    return false;
  } // Make sure some permissions were passed or check them


  if (permissions.size < 1) {
    return true;
  } else if (!currentPermissions) {
    return false;
  } else {
    // Verify all permissions are in the list
    for (var i = 0, len = permissions.size; i < len; i++) {
      if (currentPermissions.List.indexOf(permissions.get(i)) < 0) {
        return false;
      }
    }
  } // All good!


  return true;
}), _defineProperty(_Auth, "logoutCleanup", function logoutCleanup() {
  var token = new Token();
  token.deleteSession();
  token.deleteMfaSession();
  return Api.post(API.auth, ACCOUNT_LOGOUT);
}), _defineProperty(_Auth, "logout", function logout() {
  Logout.logout();
}), _defineProperty(_Auth, "logoutForced", function logoutForced() {
  Logout.logoutForced();
}), _defineProperty(_Auth, "logoutDirectlyToNewLogout", function logoutDirectlyToNewLogout() {
  Logout.logoutDirectlyToNewLogout();
}), _defineProperty(_Auth, "onChange", function onChange() {}), _Auth);
export { Logout, Token, Location };
export * from './reducers';
export * from './actions';
export * from './sagas';
export { default as hasPermission } from './hasPermission';
export * from './lockStatus';
export default Auth;